import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Listings = lazy(() => import('../pages/listings/page'));
const Listing = lazy(() => import('../pages/listing/page'));
const Sell = lazy(() => import('../pages/sell/page'));
const Neighborhoods = lazy(() => import('../pages/neighborhoods/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/listings',
    element: <Listings />,
  },
  {
    path: '/listing/:id',
    element: <Listing />,
  },
  {
    path: '/sell',
    element: <Sell />,
  },
  {
    path: '/neighborhoods',
    element: <Neighborhoods />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;